"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubjectStatsSchema = void 0;
const zod_1 = require("zod");
exports.SubjectStatsSchema = zod_1.z.object({
  /** Количество опубликованных уроков */
  content_count: zod_1.z.number(),
  /** Количество публичных митингов */
  meeting_count: zod_1.z.number(),
  /** Количество опубликованных индивидуальных занятий */
  service_count: zod_1.z.number()
});
